import PropTypes from 'prop-types';
import './style.css';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { PATH_HISTORY, TOKEN_ID } from '../../../router/config';

const Revision = ({ revision, tokenId, name, labels }) => (
    revision > 1 ?
        <div className="coe__boardName__revision">
            {
                tokenId ?
                    <Typography variant="caption">
                        {
                            labels.formatString(
                                labels.forkedFrom,
                                <Link className="coe__boardName__revision__link" to={ PATH_HISTORY.replace( TOKEN_ID, tokenId ) }>{ name }</Link>
                            )
                        }
                    </Typography> :
                    null
            }
            <Typography variant="caption">
                {
                    labels.formatString(
                        labels.revision,
                        revision
                    )
                }
            </Typography>
        </div> :
        null
)

Revision.propTypes = {
    forkedFrom: PropTypes.string,
    revision: PropTypes.number,
    labels: PropTypes.shape({
        forkedFrom: PropTypes.string,
        revision: PropTypes.string
    })
}

export default Revision;